import {
  AdminFetchRetryConfigTemplates,
  AdminUpdateRetryConfigTemplate,
} from 'src/constants/actionTypes'
import type { RetryConfigTemplate } from 'src/interfaces/retryConfigTemplate'
import { resolveErrorMessage } from 'src/utils/sagaErrorMessage'
import { Action } from 'src/utils/reduxUtils'
import type { RetryConfigTemplateState } from './types'

const getInitialState = (): RetryConfigTemplateState => {
  return {
    templates: [],
    loading: false,
    error: null,
    saving: false,
  }
}

export const retryConfigTemplateReducer = (
  state: RetryConfigTemplateState = getInitialState(),
  action: Action<unknown>,
): RetryConfigTemplateState => {
  switch (action.type) {
    // The rows are deliberately NOT cleared here: this catalog is refetched after every save,
    // and blanking a one-row table mid-edit reads as data loss.
    case AdminFetchRetryConfigTemplates.type.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case AdminFetchRetryConfigTemplates.type.SUCCESS: {
      const templates = (action.payload as RetryConfigTemplate[] | undefined) ?? []

      return {
        ...state,
        templates,
        loading: false,
        error: null,
      }
    }
    case AdminFetchRetryConfigTemplates.type.FAILED:
      return {
        ...state,
        loading: false,
        error: resolveErrorMessage(action.payload, 'Failed to load retry config templates'),
      }

    // The update never writes to `templates` — the list is refetched on success, which is the
    // single source of truth. Same shape as `marketReducer`.
    case AdminUpdateRetryConfigTemplate.type.REQUEST:
      return {
        ...state,
        saving: true,
      }
    case AdminUpdateRetryConfigTemplate.type.SUCCESS:
    case AdminUpdateRetryConfigTemplate.type.FAILED:
      return {
        ...state,
        saving: false,
      }

    default:
      return state
  }
}
